// src/api/apiService.js
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Submit Form
export const submitRegisterDetails = async (data, tripName, files) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("file", file);
  });

  formData.append(
    "personalInfo",
    new Blob([JSON.stringify(data)], { type: "application/json" })
  );

  formData.append("tripName", new Blob([tripName], { type: "text/plain" }));

  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/api/personal`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("submitPersonalDetails Error:", error);
    throw error;
  }
};

// Update Form
export const updateRegisterDetails = async (
  data,
  tripName,
  personalId,
  files
) => {
  const formData = new FormData();
  //formData.append("file", file);
  files.forEach((file) => {
    formData.append("file", file);
  });

  // Append personalInfo as JSON blob
  formData.append(
    "personalInfo",
    new Blob([JSON.stringify(data)], { type: "application/json" })
  );

  // Append other fields as plain strings
  // formData.append("tripId", tripId);
  formData.append("tripName", new Blob([tripName], { type: "text/plain" }));
  formData.append("personalId", personalId.toString());

  try {
    const response = await axios.put(
      `${API_BASE_URL}/v1/api/personal`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update Personal Details Error:", error);
    // Extract a clean error message from API
    let apiMessage = "Something went wrong while updating details.";
    if (
      error.response &&
      Array.isArray(error.response.data) &&
      error.response.data.length > 0 &&
      error.response.data[0].message
    ) {
      apiMessage = error.response.data[0].message;
    }

    // Throw a new Error with the clean message
    throw new Error(apiMessage);
  }
};

// FILE UPLOAD API
export const uploadFileToServer = async (formData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/v1/api/passport/extract`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("File Upload Error:", error);
    throw error;
  }
};

// Get All Users
export const getAllUsers = async () => {
  try {
    const payload = {
      personalId: "", // optional: use null to fetch all
      pageIndex: 0,
      pageSize: 100,
      sortBy: "personalId",
      sortOrder: "ASC",
    };

    const response = await axios.post(
      `${API_BASE_URL}/v1/api/personal/search`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );

    // ✅ If the actual list is inside `response.data.data`, adjust accordingly
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

// Login Send Otp
export const sendOtp = async (email) => {
  const payload = { email };
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/create`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, // Enables sending cookies like biblical-token
    }
  );

  return response.data;
};

export const getLoginStatus = async (email) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/status`,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const verifyLoginOtp = async (email, otp) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/otp/verify`,
    { email, otp },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const verifyEmailAndSendOtp = async (email) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/verify-email`,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const skipLoginOtp = async (email) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/otp/skip`,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const createLoginPassword = async (email, newPassword, confirmPassword) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/password/create`,
    { email, newPassword, confirmPassword },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const verifyGeneratedPassword = async (email, generatedPassword, tripName) => {
  const token = btoa(unescape(encodeURIComponent(`${email}:${generatedPassword}`)));
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/verify-generated-password`,
    { email, tripName },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const requestForgotPasswordOtp = async (email) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/forgot-password/request`,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const verifyForgotPasswordOtp = async (email, otp) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/forgot-password/verify`,
    { email, otp },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const resetForgotPassword = async (email, newPassword, confirmPassword) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/forgot-password/reset`,
    { email, newPassword, confirmPassword },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const loginWithPassword = async (email, password, tripName) => {
  const token = btoa(unescape(encodeURIComponent(`${email}:${password}`)));
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/access`,
    { email, tripName },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
      withCredentials: true,
    }
  );

  return response;
};

// Login Verify Otp
export const verifyOtp = async (email, otp, tripName) => {
  const token = btoa(unescape(encodeURIComponent(`${email}:${otp}`)));

  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/access`,
    { email, tripName: tripName }, // JSON body (as shown in curl)
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      },
      withCredentials: true, // enables sending/receiving cookies
    }
  );

  return response.data;
};

// Verify New User
export const verifyUser = async (email, tripName) => {
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/personal/check/${email}/${tripName}`,
    { withCredentials: true }
  );
  return response.data;
};

// Verify Email
export const getUserWithEmail = async (email, tripName) => {
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/personal/email/${email}/${tripName}`,
    { withCredentials: true }
  );
  return response.data;
};

export const getFlightDetials = async (flightNumber, departureDate) => {
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/flights/flightDetails?flightNumber=${flightNumber}&departureDate=${departureDate}`,
    { withCredentials: true }
  );
  return response.data;
};

export const getPassportImage = async (personalId) => {
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/personal/getPic?personalId=${personalId}`,
    {
      responseType: "blob",
      withCredentials: true,
    }
  );
  return response.data;
};

export const createTripByName = async (tripName) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/trip/createTrip?tripName=${encodeURIComponent(
      tripName
    )}`,
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const packageOptionDetials = async (tripName) => {
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/package-options/all?tripName=${encodeURIComponent(
      tripName
    )}`,
    {
      withCredentials: true,
    }
  );
  return response.data;
};

export const getAccommodationDetials = async (name, email, tripName) => {
  const encodedEmail = encodeURIComponent(email);
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/personal/verifyMainUser?name=${name}&emailId=${encodedEmail}&tripName=${tripName}`,
    {
      withCredentials: true,
    }
  );
  return response.data;
};

export const sendInviteLink = async (formData, tripName) => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/api/login/invite?firstName=${formData.firstName}&lastName=${formData.lastName}&emailId=${formData.email}&tripName=${tripName}&senderName=${formData.senderName}&senderEmailId=${formData.senderEmailId}`,
    { withCredentials: true }
  );

  return response.data;
};

export const deleteChild = async (personalId, tripName) => {
  const response = await axios.delete(
    `${API_BASE_URL}/v1/api/personal/deleteChild?personalId=${personalId}&tripName=${tripName}`,
    { withCredentials: true }
  );
  return response.data;
};

// Verify Participant Email
export const verifyParticipantEmail = async (email, tripName) => {
  const encodedEmail = encodeURIComponent(email);
  const response = await axios.get(
    `${API_BASE_URL}/v1/api/personal/verifyEmailForTrip?emailId=${encodedEmail}&tripName=${tripName}`,
    {
      withCredentials: true,
    }
  );
  return response.data;
};
